import { atom, useRecoilState } from 'recoil'

const activityFilterDefault = {
    filter: '',
    authorizedOnly: true,
}
const activityFilterState = atom({
    key: 'activityFilterState',
    default: activityFilterDefault
})

export const useActivityFilter = () => useRecoilState(activityFilterState)